"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postInitiativesSyncJiraSlice = void 0;
const xuder_1 = require("@sonar-software/xuder");
const _api_1 = require("../../../../../api/index.js");
const update_1 = require("../../@sync/update.js");
const name_1 = require("../name.js");
exports.postInitiativesSyncJiraSlice = (0, xuder_1.createPostAsyncSlice)({
    httpSagaOptions: {
        errorCodeActionCreators: [
            () => update_1.initiativesJiraIssueUpdateSlice.syncActionCreator({
                issueKey: ''
            })
        ],
        preRequestActionCreators: [
            (request) => update_1.initiativesJiraIssueUpdateSlice.syncActionCreator({
                issueKey: request.issueKey
            })
        ]
    },
    name: name_1.InitiativeSyncJiraIssueName,
    receive: false,
    request: true,
    requestHandler: _api_1.postInitiativesSyncJira
});
//# sourceMappingURL=post.js.map